import React, { useEffect, useRef } from "react";
import * as s from "./Toast.module.css";

function useLockBodyScroll(lock = true) {
  const scrollY = useRef(0);

  useEffect(() => {
    if (!lock) return;

    // Save current scroll position and lock the body (no layout shift)
    scrollY.current = window.scrollY || 0;
    const { style } = document.body;

    const prev = {
      position: style.position,
      top: style.top,
      width: style.width,
      overflowY: style.overflowY,
    };

    style.position = "fixed";
    style.top = `-${scrollY.current}px`;
    style.width = "100%";
    style.overflowY = "scroll"; // keeps scrollbar gutter

    return () => {
      // Restore
      style.position = prev.position || "";
      style.top = prev.top || "";
      style.width = prev.width || "";
      style.overflowY = prev.overflowY || "";
      window.scrollTo(0, scrollY.current);
    };
  }, [lock]);
}

export default function SuccessModal({
  title = "Success",
  message = "Check your email for a confirmation. We’ll see you soon!",
  ctaText = "OK",
  onClose,
}) {
  useLockBodyScroll(true);

  const btnRef = React.useRef(null);

  const onBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  return (
    <div
      className={s.backdrop}
      role="dialog"
      aria-modal="true"
      aria-labelledby="success-title"
      onMouseDown={onBackdropClick}
    >
      <div className={s.card}>
        <button
          aria-label="Close"
          onClick={onClose}
          className={s.close}
          type="button"
        >
          ×
        </button>
        <div className={s.iconWrap}>
          <div className={s.iconCircle}>
            <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
                fill="currentColor"
              />
              <path
                d="m8.5 12.5 2.5 2.5 4.5-5"
                stroke="#fff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
            </svg>
          </div>
        </div>
        <h3 id="success-title" className={s.title}>
          {title}
        </h3>
        <p className={s.message}>{message}</p>
        <button ref={btnRef} className={s.cta} type="button" onClick={onClose}>
          {ctaText}
        </button>
      </div>
    </div>
  );
}
